import { useState } from 'react';
import { Modal } from '../Modal';
import { useDeleteOrder } from '../../api/mutations';
import { btnSecondary, fieldLabelCls, textareaCls } from '../../lib/styles';

interface Props {
  orderId: string;
  onClose: () => void;
  onDone: () => void;
}

export function DeleteModal({ orderId, onClose, onDone }: Props) {
  const [reason, setReason] = useState('');
  const [error, setError] = useState<string | null>(null);
  const del = useDeleteOrder(orderId);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (!reason.trim()) {
      setError('Укажите причину');
      return;
    }
    try {
      await del.mutateAsync({ reason: reason.trim() });
      onDone();
    } catch (err) {
      setError((err as Error).message);
    }
  }

  return (
    <Modal title={`Удалить заявку ${orderId}`} onClose={onClose}>
      <form onSubmit={submit} className="space-y-4">
        <p className="text-sm text-text2">
          Заявка будет переведена в статус «Удалена» и исключена из всех расчётов
          (балансы, профит, транзакции). Восстановление недоступно.
        </p>
        <label className="block">
          <span className={fieldLabelCls}>Причина</span>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
            autoFocus
            className={textareaCls}
            placeholder="Например: тестовая заявка / ошибка ввода"
          />
        </label>
        {error && (
          <div className="rounded-md border border-[var(--red-border)] bg-[var(--red-bg)] px-3 py-2 text-sm text-danger">
            {error}
          </div>
        )}
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className={btnSecondary}>
            Отмена
          </button>
          <button
            type="submit"
            disabled={del.isPending}
            className="inline-flex h-9 items-center justify-center gap-2 rounded-md bg-danger px-3.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-danger"
          >
            {del.isPending ? 'Удаление…' : 'Удалить'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
